import script from "./NotesAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesAccordion.vue?vue&type=script&setup=true&lang=js"

import "./NotesAccordion.vue?vue&type=style&index=0&id=8673d308&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8673d308"]])

export default __exports__